module.exports = __webpack_public_path__ + "img/your_favs_heart.1e353ca1.svg";